<template>
  <div>
    <Menu />

    <section>
      <div class="container-fluid g-0 pt-3">
        <div class="row g-0">
          <div class="col text-center">
            <div class="developments-banner">
              <div class="row">
                <div class="col-lg-6 mx-auto align-self-center switch-white pb-5">
                  <h1 class="display-2 pb-5">New Developments</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section v-if="loading" class="mb-5">
      <div class="container">
        <div class="row pt-5">
          <div class="col-md-12 text-center">
            <p>Loading developments…</p>
          </div>
        </div>
      </div>
    </section>

    <section v-else-if="error" class="mb-5">
      <div class="container">
        <div class="row pt-5">
          <div class="col-md-12 text-center">
            <p>{{ error }}</p>
          </div>
        </div>
      </div>
    </section>

    <template v-else-if="developments.length">
      <section
        v-for="(development, developmentIndex) in developments"
        :key="development._recordKey"
        :class="developmentIndex % 2 ? 'bg-light mt-5 mb-5 pb-5' : 'mb-5'"
      >
        <div class="container g-5">
          <div class="row pt-5">
            <div class="col-md-12 pb-5 text-center">
              <p>Introducing</p>
              <h2>{{ development.name }}</h2>
              <p class="text-black">{{ development.description }}</p>
            </div>

            <div
              v-for="(image, imageIndex) in development.images"
              :key="image"
              :class="[imageColumnClass(development.images.length), 'text-center', 'pb-5']"
            >
              <img
                :src="image"
                :alt="development.name + ' image ' + (imageIndex + 1)"
                class="img img-fluid"
              >
            </div>
          </div>
        </div>

        <center v-if="development.downloadPackUrl">
          <button
            type="button"
            class="btn cta-btn m-1"
            data-bs-toggle="modal"
            data-bs-target="#developmentPackModal"
            @click="openPackModal(development)"
          >
            Download Brochure
          </button>
        </center>
      </section>
    </template>

    <section v-else class="mb-5">
      <div class="container">
        <div class="row pt-5">
          <div class="col-md-12 text-center">
            <p>No new developments are currently available.</p>
          </div>
        </div>
      </div>
    </section>

    <div
      id="developmentPackModal"
      class="modal fade"
      tabindex="-1"
      aria-labelledby="developmentPackModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="developmentPackModalLabel" class="modal-title">
              Download {{ selectedDevelopment ? selectedDevelopment.name : 'development' }} brochure
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="container mb-5">
              <div class="row">
                <form class="formStyle" @submit.prevent="submitPackForm">
                  <div class="col-md-12 ps-0">
                    <div class="banner-section agentForm pb-0 ps-0">
                      <input
                        id="developmentPackName"
                        v-model.trim="packForm.name"
                        type="text"
                        class="form-control mb-2"
                        placeholder="YOUR NAME"
                      >
                      <span class="error-message">{{ packForm.errors.name }}</span>

                      <input
                        id="developmentPackPhone"
                        v-model.trim="packForm.phone"
                        type="tel"
                        class="form-control mb-2"
                        placeholder="YOUR PHONE"
                      >
                      <span class="error-message">{{ packForm.errors.phone }}</span>

                      <input
                        id="developmentPackEmail"
                        v-model.trim="packForm.email"
                        type="email"
                        class="form-control mb-2"
                        placeholder="YOUR EMAIL"
                      >
                      <span class="error-message">{{ packForm.errors.email }}</span>
                    </div>

                    <div class="col-md-12">
                      <div class="form-check mb-2">
                        <input
                          id="developmentPackTerms"
                          v-model="packForm.acceptTerms"
                          type="checkbox"
                          class="form-check-input"
                        >
                        <label class="form-check-label" for="developmentPackTerms">
                          I have read and accept the
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.chaseveritt.co.za/disclaimer-policy-website/"
                            class="switch-blue"
                          >
                            terms and conditions
                          </a>
                        </label>
                      </div>

                      <div class="form-check mb-2">
                        <input
                          id="developmentPackMarketing"
                          v-model="packForm.receiveMarketing"
                          type="checkbox"
                          class="form-check-input"
                        >
                        <label class="form-check-label" for="developmentPackMarketing">
                          I want to receive marketing material
                        </label>
                      </div>

                      <button
                        type="submit"
                        class="btn btn-secondary"
                        :disabled="!packForm.acceptTerms || submittingPack"
                      >
                        {{ submittingPack ? 'SENDING…' : 'SEND' }}
                      </button>

                      <div v-if="successMessage" class="success-message pb-2">{{ successMessage }}</div>
                      <div v-if="formError" class="error-message pb-2">{{ formError }}</div>

                      <div v-if="downloadReady && selectedDevelopment" class="mt-3">
                        <a
                          :href="selectedDevelopment.downloadPackUrl"
                          class="btn btn-success"
                          :download="downloadFileName(selectedDevelopment)"
                        >
                          Download Brochure
                        </a>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid py-3" style="background-color: #255699; margin-top: 1rem;">
      <div class="row p-2 justify-content-center">
        <div class="col-md-6 p-4">
          <h2 class="text-white">The Winelands Awaits</h2>
          <p class="text-white">
            Contact us at
            <a class="text-white" href="mailto:admin.valdevie@everitt.co.za">admin.valdevie@everitt.co.za</a> or
            <a class="text-white" href="tel:+27832581212">+27 83 258 1212</a> or fill out the form below.
          </p>
          <ContactForm />
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import axios from 'axios'
import Menu from '@/components/Menu.vue'
import Footer from '@/components/Footer.vue'
import ContactForm from '@/components/ContactForm.vue'
import {
  apiErrorMessage,
  getDevelopmentData,
  getRecordPayload,
  listManagedRecords
} from '@/services/winelandsApi'

const SENDGRID_FORM_ENDPOINT = 'https://stratitude.co.za/api/agentForm.php'

function mediaUrl(value) {
  if (typeof value === 'string') return value.trim()
  if (!value || typeof value !== 'object') return ''
  return String(value.url || value.src || value.path || '').trim()
}

function developmentImages(payload, development) {
  const images = []
  const sources = [
    development.images,
    development.development_images,
    payload.development_images
  ]

  sources.forEach(function (source) {
    if (!Array.isArray(source)) return
    source.forEach(function (image) {
      const url = mediaUrl(image)
      if (url && images.indexOf(url) === -1) images.push(url)
    })
  })

  const legacyFeatured = mediaUrl(development.featured_image || payload.featured_image)
  if (legacyFeatured && images.indexOf(legacyFeatured) === -1) images.unshift(legacyFeatured)
  return images.slice(0, 4)
}

function developmentPack(payload, development) {
  const pack = development.download_pack || payload.download_pack || {}
  return {
    url: mediaUrl(pack) ||
      mediaUrl(development.download_pack_url) ||
      mediaUrl(payload.download_pack_url),
    name: String(
      (pack && typeof pack === 'object' && (pack.name || pack.file_name)) ||
      development.download_pack_name ||
      payload.download_pack_name ||
      ''
    ).trim()
  }
}

function blankPackForm() {
  return {
    name: '',
    email: '',
    phone: '',
    receiveMarketing: false,
    acceptTerms: false,
    errors: {
      name: '',
      email: '',
      phone: ''
    }
  }
}

export default {
  name: 'Developments',

  components: {
    Menu,
    Footer,
    ContactForm
  },

  data: function () {
    return {
      developments: [],
      selectedDevelopment: null,
      loading: true,
      error: '',
      packForm: blankPackForm(),
      submittingPack: false,
      successMessage: '',
      formError: '',
      downloadReady: false
    }
  },

  mounted: function () {
    this.loadDevelopments()
  },

  methods: {
    loadDevelopments: async function () {
      this.loading = true
      this.error = ''

      try {
        const records = await listManagedRecords('development')
        this.developments = records.map(function (record, index) {
          const payload = getRecordPayload(record)
          const development = getDevelopmentData(record)
          const pack = developmentPack(payload, development)

          return {
            _recordKey: record.ref_id || record.id || 'development-' + index,
            name: development.name || development.title || 'Untitled development',
            description: development.description || '',
            status: development.status || 'Active',
            images: developmentImages(payload, development),
            downloadPackUrl: pack.url,
            downloadPackName: pack.name
          }
        }).filter(function (development) {
          return String(development.status).toLowerCase() === 'active'
        })
      } catch (error) {
        this.error = apiErrorMessage(error, 'Could not load the developments.')
      } finally {
        this.loading = false
      }
    },

    imageColumnClass: function (imageCount) {
      if (imageCount >= 4) return 'col-md-3'
      if (imageCount === 3) return 'col-md-4'
      if (imageCount === 2) return 'col-md-6'
      return 'col-md-12'
    },

    openPackModal: function (development) {
      this.selectedDevelopment = development
      this.packForm = blankPackForm()
      this.successMessage = ''
      this.formError = ''
      this.downloadReady = false
    },

    submitPackForm: async function () {
      this.packForm.errors = {
        name: '',
        email: '',
        phone: ''
      }
      this.successMessage = ''
      this.formError = ''
      this.downloadReady = false

      if (!this.packForm.name) {
        this.packForm.errors.name = 'Name is required'
      }
      if (!this.packForm.email) {
        this.packForm.errors.email = 'Email is required'
      }
      if (!this.packForm.phone) {
        this.packForm.errors.phone = 'Phone is required'
      } else if (!/^\d+$/.test(this.packForm.phone)) {
        this.packForm.errors.phone = 'Phone must contain only numeric characters'
      }
      if (!this.selectedDevelopment || !this.selectedDevelopment.downloadPackUrl) {
        this.formError = 'This brochure is not currently available.'
      }

      const hasErrors = Object.keys(this.packForm.errors).some(function (key) {
        return Boolean(this.packForm.errors[key])
      }, this)
      if (hasErrors || this.formError) return

      this.submittingPack = true
      try {
        await axios.post(SENDGRID_FORM_ENDPOINT, {
          name: this.packForm.name,
          email: this.packForm.email,
          phone: this.packForm.phone,
          message: '',
          receiveMarketing: this.packForm.receiveMarketing,
          source: this.selectedDevelopment.name + ' Download'
        })

        this.successMessage = 'Email has been sent and an agent will be in contact with you soon.'
        this.downloadReady = true
        this.downloadPack()
        this.packForm = blankPackForm()
      } catch (error) {
        this.formError = 'Email sending failed.'
      } finally {
        this.submittingPack = false
      }
    },

    downloadFileName: function (development) {
      if (development.downloadPackName) return development.downloadPackName
      return String(development.name || 'Development')
        .replace(/[^a-z0-9]+/gi, '-')
        .replace(/^-+|-+$/g, '') + '-Brochure'
    },

    downloadPack: function () {
      if (!this.selectedDevelopment || !this.selectedDevelopment.downloadPackUrl) return

      const link = document.createElement('a')
      link.href = this.selectedDevelopment.downloadPackUrl
      link.setAttribute('download', this.downloadFileName(this.selectedDevelopment))
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style scoped>
.btn-secondary:hover,
.btn-success:hover {
  border: 1px solid #000;
  color: #000;
}
</style>
